
    <ul class="fdm-tree-structure">
        <folder-node *ngFor="let cur of rootLevels | async" [folder]="cur" [_selectedFolder]="_selectedFolder" (change)="changed($event)"></folder-node>
    </ul>
    